<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      @success="onSuccess"
      :submitService="submitService"
      :submitData="submitData"
      @openAddDialog="handleExport"
      buttonType="warning"
      buttonName="导出"
      addShowPower="/fin/adjustExport"
      :showDownloadPower="true"
      showDownloadPowerType="purple"
      downloadPowerText="合计"
      downloadPower="/statistics/qpayInfoQry"
      @down="down"
    >
      <select-organs v-model="formModel.tatSimpleId"></select-organs>
      <el-form-item label="会员名称">
        <el-input
          type="text"
          maxlength="11"
          v-model="formModel.username"
          placeholder="请输入会员名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="调账类型">
        <el-select v-model="formModel.adjustType">
          <el-option
            v-for="item in AccAdjTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="调账状态">
        <el-select v-model="formModel.status">
          <el-option
            v-for="item in status"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="调账日期">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="手机号码">
        <el-input
          type="text"
          maxlength="11"
          v-model="formModel.phone"
          placeholder="请输入手机号码"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          type="text"
          v-model="formModel.remark"
          placeholder="请输入备注信息"
        ></el-input>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="tatSimpleId"
        label="调账机构简称"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="adjustType"
        label="调账类型"
        :formatter="formatAdjTypee"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="调账状态"
        :formatter="formatStatus"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="memId"
        label="会员名称"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="手机号"
        min-width="150"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="调账日期"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="adjustAmt"
        label="调账金额（元）"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableNumber"
      ></el-table-column>
      <el-table-column
        prop="modifier"
        label="操作人"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
    </common-table>

    <show-info-dialog
      title="合计"
      :show="true"
      ref="showInfoDialog"
      dialogWidth="400px"
      class="showInfoDialog"
    >
      <div>
        <p>调账金额：{{ toDoubleThousands(dialogAmount) }}元</p>
      </div>
    </show-info-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import SelectOrgans from "components/business/SelectOrgans";
import ShowInfoDialog from "../../dialog/ShowInfoDialog";

import FinanceService from "service/FinanceService";
import OrganService from "service/OrganService";
import StatisticsService from "service/StatisticsService";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";
import TimeRange from "service/constant/TimeRange";

export default {
  name: "accountadjustmentdetail",
  components: {
    CommonTopForm,
    CommonTable,
    SelectOrgans,
    ShowInfoDialog,
  },
  data() {
    return {
      formModel: {
        tatSimpleId: "",
        username: "",
        status: "",
        adjustType: "",
        phone: "",
        remark: "",
        time: TimeRange.dayRange,
      },
      all: [
        {
          id: "",
          simpleName: "全部",
        },
      ],
      tableData: [],
      params: {},
      page: {},
      isPage: false,
      AccAdjTypes: [],
      status: [
        {
          dictKey: "",
          dictValue: "全部",
        },
        {
          dictKey: "0",
          dictValue: "处理中",
        },
        {
          dictKey: "1",
          dictValue: "成功",
        },
        {
          dictKey: "2",
          dictValue: "失败",
        },
      ],
      dialogAmount: 0,
      submitService: FinanceService.getadjusts,
    };
  },
  mixins: [loadMixin, dialogMixin],
  mounted() {
    this.getTypeNames("调账类型", (res) => {
      this.AccAdjTypes = [
        {
          dictKey: "",
          dictValue: "全部",
        },
        ...res,
      ];
    });
    this.page = this.$refs.commonTable.page;
    this.getList();
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      this.params = {
        userId: this.userId,
        tatSimpleId: this.formModel.tatSimpleId,
        status: this.formModel.status,
        username: this.formModel.username,
        adjustType: this.formModel.adjustType,
        startDate: this.formModel.time[0],
        endDate: this.formModel.time[1],
        phone: this.formModel.phone,
        remark: this.formModel.remark,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };

      if (this.formModel.time.length == 0) {
        delete this.params.startDate;
        delete this.params.endDate;
      }

      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  methods: {
    down() {
      this.doLoad(
        StatisticsService.statisGetAdjusts,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogAmount = 0;
            if (result) {
              this.dialogAmount = result.adjustAmt;
            }
            this.$nextTick(() => {
              this.$refs.showInfoDialog.open();
            });
          });
        },
        "信息获取失败"
      );
    },
    formatAdjTypee(row, column, cellValue) {
      let value = "";
      this.AccAdjTypes.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value ? value : "--";
    },
    formatStatus(row, column, cellValue) {
      let value = "";
      this.status.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value ? value : "--";
    },
    handleExport() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "adjustExport",
            "",
            "/fin/"
          )
        : "";
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        FinanceService.getadjusts,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result.rows;

            this.page.currentPage = result.current;
            this.page.pageSize = result.size;
            this.page.total = result.total;
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    addInfo() {},
    onSuccess(data) {
      const result = data.contents;
      this.tableData = result.rows;
      this.page.currentPage = result.current;
      this.page.total = result.total;
      this.page.pageSize = result.size;
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/AccountAdjustmentDetail.vue